module.exports = {
  API_PATH: (process.env.NODE_ENV === 'development' ? 'http://192.168.9.7/bkkmenu2017/web/index.php/' : (location.host == '192.168.9.7' ? 'http://192.168.9.7/bkkmenu2017/web/index.php/' : 'https://www.bkkmenu.com/')),
  THEME_PATH: (process.env.NODE_ENV === 'development' ? 'http://192.168.9.7/bkkmenu2017/web/' : (location.host == '192.168.9.7' ? 'http://192.168.9.7/bkkmenu2017/web/' : 'https://www.bkkmenu.com/'))
}
